import { render } from "./success-message.vue?vue&type=template&id=8b8e27f8&ts=true"
import script from "./success-message.ts?vue&type=script&lang=ts&external"
export * from "./success-message.ts?vue&type=script&lang=ts&external"

import "./success-message.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__